import React from 'react'

import Attachment from "../../../../../model2/attachment/attachment"
import {AttachmentSystemType} from "../../../../../model2/attachment/@types"
import ControlButtonStandard from "../../../../buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../buttons/control-button/@types"

type Props = {
    className?   : string

    attachment   : Attachment
}

// const debug = "AttachmentButtonDownload"
const debug = false

export default function AttachmentButtonDownload(props: Props):any {

    if (!props.attachment) return false

    const onClickBtn = (e: any) => {
        e.stopPropagation()

        debug && console.log(debug, "onClickBtn", props.attachment?.systemType)

        switch (props.attachment?.systemType) {
            case AttachmentSystemType.CUSTOM:
                props.attachment.downloadByFileObject()
                break

            default:
                props.attachment.download()
        }
    }

    return <ControlButtonStandard className = {props.className}
                                  size      = {ControlButtonSize.SIZE_28}
                                  iconClass = "i5-download fs-12"
                                  onClick   = {onClickBtn}/>
}
